export { useTabsContext } from "./context";
export { Tabs } from "./tabs";
export type { TabPanelGroup, TabPanelGroups, TabPanelTypeItem } from "./tabs";
export { useTabs } from "./use-tabs";
